/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GlobalFilterExclusion
 */
export interface GlobalFilterExclusion {
    /**
     * EventPipelineFilter _id this entity excludes. 24-character hex.
     * @type {string}
     * @memberof GlobalFilterExclusion
     */
    filterId: string;
    /**
     * Why this global was excluded. Required — break-glass governance is enforced at the schema, not the form.
     * @type {string}
     * @memberof GlobalFilterExclusion
     */
    reason: string;
    /**
     * Admin user _id who created the exclusion. Stamped server-side.
     * @type {string}
     * @memberof GlobalFilterExclusion
     */
    excludedBy: string;
    /**
     * Epoch ms the exclusion was created. Stamped server-side.
     * @type {number}
     * @memberof GlobalFilterExclusion
     */
    excludedAt: number;
    /**
     * Absolute epoch ms the exclusion stops applying. Required — an exclusion with no end date is the permanent break-glass D2(b) exists to prevent. Enforced at read, never by a sweeper, so it stops working the moment it expires rather than whenever a cron next runs.
     * @type {number}
     * @memberof GlobalFilterExclusion
     */
    expiresAt: number;
}

/**
 * Check if a given object implements the GlobalFilterExclusion interface.
 */
export function instanceOfGlobalFilterExclusion(value: object): value is GlobalFilterExclusion {
    if (!('filterId' in value) || value['filterId'] === undefined) return false;
    if (!('reason' in value) || value['reason'] === undefined) return false;
    if (!('excludedBy' in value) || value['excludedBy'] === undefined) return false;
    if (!('excludedAt' in value) || value['excludedAt'] === undefined) return false;
    if (!('expiresAt' in value) || value['expiresAt'] === undefined) return false;
    return true;
}

export function GlobalFilterExclusionFromJSON(json: any): GlobalFilterExclusion {
    return GlobalFilterExclusionFromJSONTyped(json, false);
}

export function GlobalFilterExclusionFromJSONTyped(json: any, ignoreDiscriminator: boolean): GlobalFilterExclusion {
    if (json == null) {
        return json;
    }
    return {
        
        'filterId': json['filterId'],
        'reason': json['reason'],
        'excludedBy': json['excludedBy'],
        'excludedAt': json['excludedAt'],
        'expiresAt': json['expiresAt'],
    };
}

export function GlobalFilterExclusionToJSON(json: any): GlobalFilterExclusion {
    return GlobalFilterExclusionToJSONTyped(json, false);
}

export function GlobalFilterExclusionToJSONTyped(value?: GlobalFilterExclusion | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'filterId': value['filterId'],
        'reason': value['reason'],
        'excludedBy': value['excludedBy'],
        'excludedAt': value['excludedAt'],
        'expiresAt': value['expiresAt'],
    };
}

